import { render, staticRenderFns } from "./DdlMailAccountComponent.vue?vue&type=template&id=2edf4976"
import script from "./DdlMailAccountComponent.vue?vue&type=script&lang=js"
export * from "./DdlMailAccountComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports